import styles from "@/styles/layout.module.css";
import { layoutBackgrounds } from "@/assets";

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      className={styles.authLayout}
      data-scroll-root
      style={layoutBackgrounds.auth}
    >
      <main>{children}</main>
    </div>
  );
};

export default AuthLayout;
